export class GetRestaurantGeneralAction {
  static readonly type: string = '[Restaurant] Get General Restaurant';
}

export class GetRestaurantProductCategoriesAction {
  static readonly type: string =
    '[Restaurant] Get Restaurant Product Categories';
}

export class GetRestaurantProductsAction {
  static readonly type: string = '[Restaurant] Get Restaurant Products';
}

export class ClearRestaurantAction {
  static readonly type: string = '[Restaurant] Clear Restaurant';
}

export class GetRestaurantPaymentMethodsAction {
  static readonly type: string = '[Restaurant] Get Restaurant Payment Options';
}

export class GetPickupLocationsAction {
  static readonly type: string = '[Restaurant] Get Pickup Locations';
}
